export default __webpack_public_path__ + "static/media/dots.07c8bbd9.svg";